import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPrompt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPrompt"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H7V5.5H3.5V9H2V4ZM17 4H22V9H20.5V5.5H17V4ZM7 9H17V10.5H7V9ZM7 13.5H15V15H7V13.5ZM3.5 15V18.5H7V20H2V15H3.5ZM22 15V20H17V18.5H20.5V15H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPrompt;
